export const LookupTypes = {
  hiddenCompany: 'hiddenCompany',
  hiddenCompanyEN: 'hiddenCompanyEN',
  driverLicences: 'driverLicence',
  questions: 'question',
  militaryStatuses: 'militaryStatus',
  educationLevels: 'educationLevel',
  languageLevels: 'languageLevel',
  workingTypes: 'workingType',
  jobPassiveReasons: 'jobPassiveReasons',
  gender: 'gender',
  maritalStatus: 'maritalStatus',
  smoking: 'smoking',
  positionLevel: 'positionLevel',
  educationDegree: 'educationDegree',
  workingStatus: 'workingStatus',
};

export const jobLanguageOptionsType = (resource) => ({
  1: {
    value: '01',
    text: resource['job.Create.JobLanguage.Turkish.Label'],
  },
  2: {
    value: '02',
    text: resource['job.Create.JobLanguage.English.Label'],
  },
});

export const JobProductTypes = (resource) => ({
  standartJob: {
    id: 1,
    displayName: resource['job.ProductType.Standart'],
  },
  marsJob: {
    id: 2,
    displayName: resource['job.ProductType.Title.Mars'],
  },
});

export const SelectionAdTypes = (resource) => ({
  ...JobProductTypes(resource),
  passMe: {
    id: 3,
    displayName: resource['job.ProductType.Title.CallMe'],
  },
});

export const GenderType = (resource) => ({
  noMatter: {
    value: 1,
    text: resource['label.DoesNotMatter'],
  },
  male: {
    value: 2,
    text: resource['label.Man'],
  },
  female: {
    value: 3,
    text: resource['label.Women'],
  },
});

export const RoleTypes = {
  admin: {
    id: 1,
  },
  managerPlus: {
    id: 12,
  },
  manager: {
    id: 2,
  },
  limitidPlus: {
    id: 8,
  },
  limited: {
    id: 3,
  },
  partner: {
    id: 7,
  },
  temporaryUser: {
    id: 11,
  },
  list: {
    id: 4,
  },
};

export const CompanyType = {
  welcome: {
    id: 0,
  },
  basic: {
    id: 1,
  },
  advanced: {
    id: 2,
  },
};

export const CountTypes = [
  'totalApplicationCount',
  'newApplicationCount',
  'favoriteCount',
  'viewCount',
  'candidatesNotRespondedCount',
  'PasUserCount',
  'NewPasUserCount',
];

export const TurkishMonthNames = {
  0: 'Ocak',
  1: 'Şubat',
  2: 'Mart',
  3: 'Nisan',
  4: 'Mayıs',
  5: 'Haziran',
  6: 'Temmuz',
  7: 'Ağustos',
  8: 'Eylül',
  9: 'Ekim',
  10: 'Kasım',
  11: 'Aralık',
};

export const DllRequestOptions = {
  searchPosition: {
    responseItemLimit: 50,
  },
  searchWithinAllowedLocations: {
    responseItemLimit: 10,
  },
  searchUniversity: {
    responseItemLimit: 10,
  },
  searchDepartment: {
    responseItemLimit: 50,
  },
};

export const CompanyPageInfoTypes = (resource) => ({
  notAdded: {
    Id: null,
    Text: resource['companyPage.Not.Added'],
    TooltipText: resource['companyPage.Not.Added.TooltipText'],
  },
  editedNotPublish: {
    Id: 0,
    Text: resource['companyPage.Edited.Not.Publish'],
    TooltipText: resource['companyPage.Edited.Not.Publish.TooltipText'],
  },
  addedNotPublish: {
    Id: -1,
    Text: resource['companyPage.Added.Not.Publish'],
    TooltipText: resource['companyPage.Added.Not.Publish.TooltipText'],
  },
  published: {
    Id: 1,
    Text: resource['companyPage.Published'],
    TooltipText: resource['companyPage.Published.TooltipText'],
  },
});

export const CompanySegments = [
  [],
  [
    'segment.basic',
    'question.create',
    'user.create',
    'message.create',
    'job.addjobpermission',
    'all.applicants',
  ],
  [],
  [],
];

export const TransferStatusType = {
  0: 'MarkedForTransfer',
  1: 'Transfered',
  2: 'TransferCompleted',
};

export const MatchStatus = {
  0: 'None',
  1: 'Partial',
  2: 'Match',
};

export const RelevancyType = {
  1: 'LastPosition',
  2: 'ExperienceYear',
  3: 'LocationCity',
  4: 'EducationStatus',
  5: 'ForeignLanguage',
  6: 'DriverLicence',
  7: 'MilitaryStatus',
  8: 'Age',
  9: 'Sector',
  10: 'PastPositions',
};

export const OrganizerSegmentType = {
  0: 'None',
  1: 'PotentialCustomer',
  3: 'KariyerClassic',
  6: 'KariyerPlus',
  9: 'KariyerProfessional',
  17: 'KariyerNetwork',
};

export const CompanyActivityStateType = {
  1: 'CompanyActiveMode',
  2: 'CompanyActiveModeInExtendedDays',
  3: 'CompanyPassiveMode',
  4: 'CompanyRestrictedMode',
};

export const PasListAdded = {
  1: 'Researcher',
  2: 'Algorithm',
  3: 'Application',
};

export const CandidateTestStatuses = {
  1: 'Created',
  3: 'Launched',
  4: 'Completed',
  5: 'ReportCreating',
  6: 'ReportCreated',
};

export const ProfileTypes = {
  1: 'companyProfile',
  2: 'universityProfile',
};

export const CompanyUserStatus = {
  0: 'Passive',
  1: 'Active',
  2: 'Deleted',
};

export const OtpEmailApproved = {
  0: '',
  1: 'Approved',
  2: 'NotApproved',
  3: 'ApprovedAnotherUser',
};

export const VerificationType = {
  1: 'Otp',
  2: '2fa',
};

export const ApplicationTypes = {
  Applications: 0,
  Associated: 1,
  Evaluated: 2,
  Relevancy: 3,
  Recommended: 4,
};

export const ReferenceTypes = {
  1: 'references.Manager',
  2: 'references.Friends',
  3: 'references.Workers',
  4: 'references.Academical',
  5: 'references.Family',
  6: 'references.PublicEmployee',
  7: 'references.Social',
};
export const KvkkStatus = {
  0: 'None',
  1: 'Created',
  2: 'SentQueue',
  3: 'Processing',
  4: 'Sent',
  5: 'Seen',
  6: 'Approved',
  7: 'Rejected',
  8: 'Error',
};
export const AssessmentTests = {
  3: 0,
  lingoby: 1,
  4: 2,
  'perspectives90-bundle-tr': 3,
  2: 4,
  'gcatatimed-bundle-tr': 5,
  5: 6,
  1: 7,
  'perspectives90-summary-bundle': 8,
};
